import LocationService from 'src/common/api/location.service';

export async function fetchAllLocations({ commit }) {
  const response = await LocationService.getAll();
  if (response.status === 200) {
    commit('updateAllLocations', { locations: response.data });
  }
}
